export class SelectListItem {
    value: string;
    text: string;
}
